import { FLOW_STEPS } from 'share/types'
import type { CurrentStepBody } from 'share/types/api/main'
import { isStepHaveData } from 'utils'

import { type CheckIINDecisionData } from './types'

export const CheckIINDecisionStepHandler = (step: CurrentStepBody) => {
  if (!step) return false
  if (step.step === FLOW_STEPS.CHECK_DECISION_IIN && isStepHaveData<CheckIINDecisionData>(step.data)) {
    return 'check_iin_error' in step.data
  }
  return false
}

export const MANUAL_STATUS_STEP_CHECK_HANDLERS: ((step: CurrentStepBody) => boolean)[] = []
